<template>
    <div style="display: flex;position: relative;">
        <img width="640" height="640" :src="imageSrc" alt="">
        <canvas id="canvas5" width="640" height="640" style="background-color: transparent;position: absolute;border-color: transparent"></canvas>
    </div>
</template>

<script>
import {nextTick, watch} from "vue";
export default {
    name: "imageDrawRect5",
    props: {
        rectObject:{
            type:Object,
            default:()=>({})
        },
        // 用来给图片地址
        imageSrc:{
            type:String,
            default:""
        }
    },
    setup(props) {
        watch(props.rectObject,
            ()=>{
                nextTick(()=>{
                    let canvas = document.getElementById("canvas5");
                    let ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    for (let key in props.rectObject){
                        let color = props.rectObject[key][4]+"";
                        ctx.globalAlpha = 0.5;
                        ctx.fillStyle = color;
                        ctx.fillRect(props.rectObject[key][0],props.rectObject[key][1],props.rectObject[key][2]-props.rectObject[key][0],props.rectObject[key][3]-props.rectObject[key][1])
                        ctx.globalAlpha = 1;
                        ctx.lineWidth = 5;
                        ctx.strokeStyle = color;
                        ctx.strokeRect(props.rectObject[key][0],props.rectObject[key][1],props.rectObject[key][2]-props.rectObject[key][0],props.rectObject[key][3]-props.rectObject[key][1]);
                        // ctx.fillStyle = color;
                        ctx.fillStyle = "#FFFFFF"; // 这里将文本颜色设置为白色
                        ctx.font = "20px Arial";
                        let TZText=props.rectObject[key][5]
                        ctx.fillText(TZText,props.rectObject[key][0],props.rectObject[key][1]+20)
                    }
                })

            },
            {immediate:true})

        /**
         * 随机生成颜色
         * @returns {string}
         */
        function getRandomColor() {
            function componentToHex(c) {
                var hex = c.toString(16);
                return hex.length === 1 ? "0" + hex : hex; // 如果只有一位数，在前面补零
            }
            var r = Math.floor(Math.random() * 256);   // 随机生成0-255之间的整数
            var g = Math.floor(Math.random() * 256);   // 随机生成0-255之间的整数
            var b = Math.floor(Math.random() * 256);   // 随机生成0-255之间的整数
            return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b); // 返回生成的随机颜色的十六进制表示
        }
        return{
            // forRendering,
            getRandomColor,
        }
    },
}
</script>

<style scoped>

</style>